export default __webpack_public_path__ + "static/media/linkedin.84927dc3.svg";